// removed by extract-text-webpack-plugin
module.exports = {"iframe":"src-display-modules-Home-LoginThird-index__iframe--3EYcZ","loadingBox":"src-display-modules-Home-LoginThird-index__loadingBox--FKMGZ"};


//////////////////
// WEBPACK FOOTER
// ./src/display/modules/Home/LoginThird/index.scss
// module id = 1081
// module chunks = 0